export default __webpack_public_path__ + "static/media/bannerAbout.3f8f02b7.jpg";